/* eslint-disable */
/**
 * This file was generated by Itecho.TSGen tool
 * Version and info generated in .version
 * Any changes to this file will be lost if regenerated 
 */

import { webRequest, fileRequest } from "../request";
import type CropBrakePointDisplay from "../interfaces/cropBrakePointDisplay";
import type Cultivar from "../interfaces/cultivar";
import type IdRequest from "../interfaces/idRequest";

export default {
    crops: () => webRequest<CropBrakePointDisplay[]>('/api/blockcrop/crops', {
        method: 'post'
    }),
    cultivarsForCrop: (request: IdRequest) => webRequest<Cultivar[]>('/api/blockcrop/cultivarsforcrop', {
        method: 'post',
        body: request
    })
}